
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/helpCenter/HelpCenter.lazy",
      function () {
        return require("private-next-pages/helpCenter/HelpCenter.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/helpCenter/HelpCenter.lazy"])
      });
    }
  